// extracted by mini-css-extract-plugin
var _1 = "AnnotationPreview-module__annotationPreview--y8lC2";
var _2 = "AnnotationPreview-module__link--KRczE";
export { _1 as "annotationPreview", _2 as "link" }
